import React from 'react';
import {  Route, Routes,useNavigate } from 'react-router-dom';
import { Card, Button } from 'antd';
import Home from './Home';
import CLComponents from './CLComponents/index';
import NavBar from './Navbar';
import EnglishLabelChange from './englishLabelChange';
import StudyPlan from './study-plan';
import AO from './AO';
import AbsentRMs from './AbsentRMs';
import DailySheet from './MathMorningSheetStatus';
import MathEveningDailySheet from './MathEveningSheetStatus';
import EnglishMorningDailySheet from './EnglishMorningSheetStatus';
import EnglishEveningDailySheet from './EnglishEveningSheetStatus';
import MathLabelChange from "./MathLabelChange"
import CLattendance from './CL-attendance';
import CentralAudit from './CentralAudit';
import '../App.css';
import { LogoutOutlined } from '@ant-design/icons';

function App() {
  const navigate = useNavigate();

  function logOut() {
    localStorage.setItem("token", null);
    navigate("/omPortal/login");
  }
  return (
    <div className="App">
      <Card style={{height:'100px'}}>
      <img src={`../img/Saarthi-blue.png`} alt=" " style={{ position: 'absolute', left: '26px' }} />
        <NavBar />
        <div style={{ position: 'absolute', right: '26px', top: '30px' }}>
          <Button onClick={logOut} style={{ color: '#1a237e', fontWeight: '600', border: 'none' }}>
            Log out &nbsp;<LogoutOutlined />
          </Button>
        </div>
      </Card>
      <Routes>
          <Route path="/home" element={<Home/>} />        
          <Route path="/studyPlan" element={<StudyPlan/>} />
          <Route path="/EnlishLabel" element={<EnglishLabelChange/>} />
          <Route path="/MathLabel" element={<MathLabelChange/>} />
          <Route path="/AO" element={<AO/>} />
          <Route path="/AbsentRMs" element={<AbsentRMs/>} />
          <Route path="/DailySheet" element={<DailySheet/>} />
          <Route path="/MathEveningDailySheet" element={<MathEveningDailySheet/>} />
          <Route path="/EnglishMorningDailySheet" element={< EnglishMorningDailySheet/>} />
          <Route path="/EnglishEveningDailySheet" element={<EnglishEveningDailySheet/>} />   
          <Route path="/CLattendance" element={<CLattendance/>} />
          <Route path="/cl/*" element={<CLComponents/>} />   
          <Route path="/CentralAudit" element={<CentralAudit/>} />
      </Routes>
    </div>
  );
}

export default App;